import { NavLink } from "react-router-dom";
import { ExternalLink } from "lucide-react";
import { SmartLink } from "@/components/SmartLink";
import { useNavItems } from "@/components/layout/Header";
import { useSite } from "@/context/SiteContext";

const slug = (s) => s.toLocaleLowerCase("tr").normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ı/g, "i").replace(/[^a-z0-9]+/g, "-");
const cls = ({ isActive }) => `block rounded px-3 py-3 text-base font-semibold ${isActive ? "bg-navy-50 text-navy" : "text-ink hover:bg-paper"}`;

export const MobileNav = ({ onNavigate }) => {
  const items = useNavItems();
  const site = useSite();
  return (
    <nav id="mobil-menu" aria-label="Mobil menü" className="max-h-[calc(100vh-72px)] overflow-y-auto border-t border-line bg-white xl:hidden" data-testid="mobile-nav">
      <ul className="container-site space-y-1 py-4">
        {items.map((item) => (
          <li key={item.label}>
            {item.children?.length ? (
              <div className="py-1">
                {item.to ? (
                  <NavLink to={item.to} end className={cls} onClick={onNavigate} data-testid={`mobile-nav-${slug(item.label)}`}>{item.label}</NavLink>
                ) : (
                  <p className="px-3 pb-1 pt-3 text-xs font-semibold uppercase tracking-[0.16em] text-ink-muted">{item.label}</p>
                )}
                <ul className="ml-3 border-l-2 border-line pl-2">
                  {item.children.map((c) => (
                    <li key={c.to}>
                      <NavLink to={c.to} className={({ isActive }) => `block rounded px-3 py-2.5 text-[15px] ${isActive ? "font-semibold text-navy" : "text-ink-soft"}`}
                        onClick={onNavigate} data-testid={`mobile-nav-${slug(c.label)}`}>{c.label}</NavLink>
                    </li>
                  ))}
                </ul>
              </div>
            ) : item.external ? (
              <>
              <SmartLink item={item} onClick={onNavigate} testId="mobile-mkk-link"
                className="mt-2 flex items-center justify-between rounded-md border border-navy px-3 py-3 text-base font-semibold text-navy">
                {item.label} <ExternalLink className="h-4 w-4" aria-hidden="true" />
              </SmartLink>
              {site.mkk_note && <p className="px-1 pt-1.5 text-sm text-ink-muted" data-testid="mobile-mkk-note">{site.mkk_note}</p>}
              </>
            ) : (
              <NavLink to={item.to} end={item.to === "/"} className={cls} onClick={onNavigate} data-testid={`mobile-nav-${slug(item.label)}`}>{item.label}</NavLink>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
};
